import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LoginRegisterComponent } from './components/login-register/login-register.component';
import { RegisterEmailComponent } from './components/register-email/register-email.component';
import { LoginComponent } from './components/login/login.component';
import { PrivacyPolicyComponent } from './components/privacy-policy/privacy-policy.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { EmailVerifiedComponent } from './components/email-verified/email-verified.component';
import { EmailSubmittedComponent } from './components/email-submitted/email-submitted.component';
import { VerifyEmailComponent } from './components/verify-email/verify-email.component';

const routes: Routes = [
  {
    path: 'registration',
    component: LoginRegisterComponent,
  },
  {
    path: 'register',
    component: RegisterEmailComponent,
  },
  {
    path: '',
    component: LoginComponent,
  },
  {
    path: 'login', // leaving this here just in case any old links were missed
    component: LoginComponent,
  },
  {
    path: 'privacy-notice',
    component: PrivacyPolicyComponent,
  },
  {
    path: 'forgotten-password',
    component: ForgotPasswordComponent,
  },
  {
    path: 'reset-password/:uuid/:token',
    component: ResetPasswordComponent,
  },
  {
    path: 'verify/:uuid/:token',
    component: VerifyEmailComponent,
  },
  {
    path: 'email-verified/:result',
    component: EmailVerifiedComponent,
  },
  {
    path: 'email-verified/:result/:email',
    component: EmailVerifiedComponent,
  },
  {
    path: 'signup/success',
    component: EmailSubmittedComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class LoginRegisterRoutingModule {}
